/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Parq_NoneInputs */

const en_us2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No yes answers: the plan runs without restrictions.`)
};

const pt_br2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma resposta positiva: o plano segue sem restrições.`)
};

const es_419_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna respuesta afirmativa: el plan sigue sin restricciones.`)
};

const pt_pt2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma resposta positiva: o plano segue sem restrições.`)
};

const fr_fr2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune réponse « oui » : le programme se déroule sans restriction.`)
};

const de_de2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ja: Der Plan läuft ohne Einschränkungen.`)
};

const it_it2_profile_parq_none = /** @type {(inputs: Profile_Parq_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna risposta sì: la scheda procede senza restrizioni.`)
};

/**
* | output |
* | --- |
* | "No yes answers: the plan runs without restrictions." |
*
* @param {Profile_Parq_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_parq_none = /** @type {((inputs?: Profile_Parq_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Parq_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_parq_none(inputs)
	if (locale === "es-419") return es_419_profile_parq_none(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_parq_none(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_parq_none(inputs)
	if (locale === "de-DE") return de_de2_profile_parq_none(inputs)
	if (locale === "it-IT") return it_it2_profile_parq_none(inputs)
	return en_us2_profile_parq_none(inputs)
});
export { profile_parq_none as "profile.parq_none" }